export function getFilterTypeFromResultColumn(type, subType) {
  if (type === "DATE") return "date";
  if (type === "INT" || type === "FLOAT") return "number";
  if (subType === "CURRENCY" || subType === "PERCENTAGE" || subType === "YEAR")
    return "number";
  return "value";
}
